export default {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280
}
